import { appConfig } from '../../../../appConfig';
import { BrowserSize } from '../../../../utility/browser';
import { useFromBrowserMediaQuery } from '../../../common/components/atoms/ResponsiveBreakpoints';
import { UserType } from '../../../common/flow/user/userModels';
import { useUserTypeQuery } from '../../../common/hooks/useUserQueries';
import UserTypeModeSwitch from '../UserTypeModeSwitch';
import FeaturedNavigation from './FeaturedNavigation';
import HeaderBanner from './HeaderBanner';
import HeaderLeftNav from './HeaderLeftNav';
import HeaderRightNav from './HeaderRightNav';

const HeaderFluidBanner = (props: {
    featuredNavigation: {
        items: React.ComponentProps<typeof FeaturedNavigation>['items'];
    };
    headerTheme: 'darkGreen' | 'black';
    stayAfterLoginLogoutRedirect: boolean;
    hideB2BSwitch: boolean;
}) => {
    const isFromLarge = useFromBrowserMediaQuery(BrowserSize.lg);
    const isFromXsm = useFromBrowserMediaQuery(BrowserSize.xsm);
    const { data: userType } = useUserTypeQuery();
    const isPunchout = userType === UserType.punchout;

    const disableMyFavoritesMenu = isPunchout || appConfig.coopUserSettings.isShoppingForMunicipal;

    return (
        <HeaderBanner.Banner headerTheme={props.headerTheme} bordered>
            {/* This is actually absolutely positioned to the right side but put here in order to be first in focus order */}
            {isFromLarge && (
                <div className="HeaderBanner-ModeSwitch">
                    {!props.hideB2BSwitch && <UserTypeModeSwitch theme="white" />}
                </div>
            )}
            <HeaderBanner.LeftSlot narrow={isFromLarge}>
                <HeaderBanner.LeftNav>
                    {isFromLarge ? (
                        <HeaderBanner.Logo />
                    ) : (
                        <>
                            <HeaderLeftNav
                                disableSiteNavigation={false}
                                navigationItems={props.featuredNavigation?.items}
                            />
                            {isFromXsm && <HeaderBanner.Logo />}
                        </>
                    )}
                </HeaderBanner.LeftNav>
            </HeaderBanner.LeftSlot>
            {!!props.featuredNavigation?.items.length && (
                <HeaderBanner.CenterSlot>
                    <FeaturedNavigation
                        indicatorPosition="top"
                        items={props.featuredNavigation?.items}
                    />
                </HeaderBanner.CenterSlot>
            )}
            <HeaderBanner.RightSlot narrow={isFromLarge}>
                <HeaderBanner.RightNav>
                    {!isFromLarge && (
                        <HeaderRightNav
                            disableMyFavoritesMenu={disableMyFavoritesMenu}
                            stayAfterLoginLogoutRedirect={props.stayAfterLoginLogoutRedirect}
                            headerTheme={props.headerTheme}
                        />
                    )}
                </HeaderBanner.RightNav>
            </HeaderBanner.RightSlot>
        </HeaderBanner.Banner>
    );
};

export default HeaderFluidBanner;
